import React from "react";
import { Dropdown, IconButton, Button } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

interface Props {
	id: string;
}

const TaskMenu = ({ id }: Props) => {
	const { t } = useTranslation();

	const history = useHistory();

	return (
		<>
			<Dropdown
				id={`tasksMenu__dropdown__${id}`}
				menuBtn={
					<IconButton
						className="btn-basic--dark"
						icon="ellipsis-v"
						label={t("main.labels.menu")}
					/>
				}
				align="right">
				<Button
					name="assign"
					label={t("main.tasks.labels.assign")}
					className="dropdown-item btn-basic--default"
					value="assign"
					onClick={() =>
						history.push(
							`${window.location.pathname}?assignId=${id}`
						)
					}
				/>
			</Dropdown>
		</>
	);
};

export default TaskMenu;
